import React from 'react';

import styled from 'styled-components';

import {
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextFieldVariants,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FormField, TextField } from 'components';

import { dayjs, useForm } from 'third-party';

import { DISPLAY_DATE_TIME_FORMAT } from 'constants/common';

import { FormFieldProps } from 'components/FormField/FormField';

const StyledDateTimePicker = styled(DateTimePicker)`
  width: 100%;
`;

const popperDateSx = {
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '1.6rem',
    textTransform: 'uppercase',
    fontWeight: 900,
  },
  '& .PrivatePickersYear-yearButton': {
    fontSize: '1.6rem',
    margin: '0.4rem 0',
    '&.Mui-selected': {
      color: '#ffffff',
    },
  },
  '& .MuiPickersDay-dayWithMargin': {
    fontSize: '1.6rem',
    color: '#5C6C80',
    '&[aria-selected="true"]': {
      color: '#ffffff',
    },
    '&[aria-current="date"]': {
      borderColor: '#AFD8D4',
      backgroundColor: '#AFD8D4',
    },
  },
};

type DateTimeFieldProps = FormFieldProps & {
  minutesStep?: number;
};

export const DateTimePickerField: React.FC<DateTimeFieldProps> = ({
  minutesStep = 15,
  ...props
}) => {
  const {
    formState: { errors },
  } = useForm();

  return (
    <FormField
      render={({ field }) => (
        <StyledDateTimePicker
          format={DISPLAY_DATE_TIME_FORMAT}
          value={field.value ? dayjs(field.value) : null}
          disabled={props.isDisabled}
          onChange={field.onChange}
          minutesStep={minutesStep}
          // @ts-ignore
          PopperProps={{
            sx: popperDateSx,
            placement: 'bottom-start',
          }}
          renderInput={(
            params: React.JSX.IntrinsicAttributes & {
              variant?: TextFieldVariants | undefined;
            } & Omit<
                | FilledTextFieldProps
                | OutlinedTextFieldProps
                | StandardTextFieldProps,
                'variant'
              >,
          ) => (
            <TextField
              size="small"
              variant="outlined"
              {...params}
              disabled={props.isDisabled}
              error={!!errors[props.fieldName] && props.showError}
            />
          )}
        />
      )}
      {...props}
    />
  );
};
